/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Add_Player_Deceased_WarnInputs */



/**
* | output |
* | --- |
* | "{name} is recorded as deceased. Register them anyway?" |
*
* @param {Add_Player_Deceased_WarnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_deceased_warn = /** @type {((inputs: Add_Player_Deceased_WarnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Deceased_WarnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} est enregistré(e) comme décédé(e). Inscrire quand même ?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} está registrado/a como fallecido/a. ¿Inscribir de todas formas?`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} está registrado/a como falecido/a. Inscrever mesmo assim?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} è registrato/a come deceduto/a. Iscrivere comunque?`)
	return /** @type {LocalizedString} */ (`${i?.name} is recorded as deceased. Register them anyway?`)
});